import { envs } from '@ctct/infrastructure-layer';

import { useBillingInfo } from '../queries';
import { useIsCanceledQuery } from '../queries/useIsCanceledQuery';

export const useIsCanceled = () => {
  if (envs.isSecure()) {
    // hooks list will be stable per env, so we can safely disable the hooks rule
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: billingInfo, isLoading, error } = useBillingInfo();

    return !isLoading && !error && billingInfo?.getIsCanceled();
  }

  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data: isCanceled, isLoading, error } = useIsCanceledQuery();

  return !isLoading && !error && isCanceled;
};

export type UseIsCanceled = ReturnType<typeof useIsCanceled>;
